import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params  } from '@angular/router';

@Component({
  selector: 'app-outage',
  templateUrl: './outage.component.html',
  styleUrls: ['./outage.component.scss']
})
export class OutageComponent implements OnInit {
  @Input() outageObj=null;
  constructor(private route: ActivatedRoute, ) { }
  public description: string;
  public backTime: Date;
  public startTime: Date;

  ngOnInit() {
    if (this.outageObj) {
      this.description = this.outageObj.description;
      this.backTime = this.outageObj.endTime;
      this.startTime = this.outageObj.startTime;
    }
   
  }

}
